import { type MarketplaceItem } from "@/services/marketplace/item";
import { type MaybeRef, unref } from "vue";

export function useMarketplaceItemStatus(marketplaceItem: MaybeRef<MarketplaceItem | undefined>) {
  const isSoldOut = computed(() => {
    const i = unref(marketplaceItem);
    if (i === undefined) {
      return undefined;
    } else if (i.quantity <= 0) {
      return true;
    } else {
      return false;
    }
  });

  return {
    isSoldOut,
  };
}
